<template>
  <div
    class="anz-posts__item-modal anz-posts__item-create-wrapper"
    :class="{ 'is-active': postEditing }"
  >
    <div
      class="anz-hidden-sm anz-mx-m anz-flex anz-justify-content-between anz-align-items-center"
    >
      <div class="anz-fs-xxxs anz-text-uppercase anz-strong ">
        {{ $translate('post.labels.editModalTitle') }}
      </div>
      <a-button
        class-name="anz-link anz-color-black-50 anz-ml-s anz-btn-close anz-mrn-m"
        @click="$emit('post-close')"
      >
        <template #title>
          <a-icon name="cross-solid" width="12px" height="12px" />
        </template>
      </a-button>
    </div>
    <div
      class="anz-bg-black-3 anz-p-m anz-mt-s anz-posts__item-create anz-b-rounded"
    >
      <div class="anz-mb-s">
        <div class="anz-fc-row anz-fc-row-emoji anz-fc-row-icon">
          <post-text
            v-if="postRaw"
            v-model="postRaw.contentRaw"
            :has-error="
              (validationError && validationError.hasError('content')) ||
                apiError
            "
            :error-messages="
              validationError
                ? validationError.getPrintableErrors()
                : apiError
                ? apiError.getPrintableErrors()
                : []
            "
          />
        </div>
      </div>

      <div
        class="anz-flex-sm anz-align-items-center anz-justify-content-between"
      >
        <div v-if="timesUp" class="anz-strong">
          {{ $translate('post.forms.editTimerTimesUp') }}
        </div>
        <div v-else class="anz-color-gray-700 anz-fs-13">
          {{ $translate('post.forms.editTimerNotice') }}
          <post-edit-timer
            :init-timer-count="timeToEdit"
            only-last-minute-seconds
            @time-is-up="timesUp = true"
          />
        </div>
        <div class="anz-mt-m anz-mt-0-sm anz-ml-m-sm anz-flex">
          <a-button
            :title="$translate('post.actions.closeButton')"
            class="anz-btn-border anz-mr-xs anz-post__item-create-close"
            @click="$emit('post-close')"
          >
          </a-button>
          <a-button
            :title="$translate('post.actions.editButton')"
            class-name="anz-btn anz-btn-primary anz-wf"
            @click="updatePost"
            :loading="loading"
            :disabled="timesUp"
          >
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Post } from '@/model/data-object/Post'
import usePostSingleLoader, {
  usePostUpdate,
} from '@/composables/post/postSinleLoader'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import PostText from '@/components/Forms/PostText.vue'
import PostEditTimer from '@/components/Post/SinglePost/PostEditTimer.vue'
import { MAX_EDIT_OPENED_AGE } from '@/composables/post/postEdit'

export default defineComponent({
  name: 'PostEdit',
  emits: ['post-updated', 'post-close'],
  components: { PostEditTimer, PostText, AButton, AIcon },
  props: {
    post: {
      type: Post,
      required: true,
    },
    postEditing: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      timesUp: false,
      timeToEdit: MAX_EDIT_OPENED_AGE,
    }
  },
  async setup(props, { emit }) {
    const postRaw = await usePostSingleLoader(props.post)

    return {
      postRaw,
      ...usePostUpdate(
        postRaw?.value ? (postRaw.value as Post) : new Post(),
        emit
      ),
    }
  },
})
</script>
